import React from 'react'
import SectionWrapperFlexible from '@components/ui/wrappers/SectionWrapperFlexible'
import styled from 'styled-components'
import { breakpoint } from '@configs/utilities'

const FreeAiToolsFormWrapper = ({ children, title }) => {
  return (
    <SectionWrapperFlexible
      sectionPaddingSm="10px 0 10px 0"
      sectionPaddingMd="10px 0 30px 0"
      sectionPaddingXl="10px 0 50px 0"
    >
      <FormWrapper>
        <FormTitle>{title}</FormTitle>
        {children}
      </FormWrapper>
    </SectionWrapperFlexible>
  )
}

export default FreeAiToolsFormWrapper

const FormWrapper = styled.div`
  padding: 50px 20px;
  border-radius: 10px;
  background: radial-gradient(50% 50% at 50% 50%, #0091ff 0%, #0e64e6 100%);

  @media screen and (min-width: ${breakpoint.md}) {
    padding: 50px 30px;
  }

  @media screen and (min-width: ${breakpoint.lg}) {
    padding: 50px 40px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    padding: 50px 50px;
  }
`
const FormTitle = styled.p`
  max-width: 600px;
  margin: 0 auto 20px;
  color: #fff;
  text-align: center;
  font-size: 36px;
  font-weight: 500;
  line-height: 40px;
`
